<div class="layout">
  <app-sidebar-menu></app-sidebar-menu>

  <div class="main-panel">
    <header class="topbar">
      <h1>Detalle de postulacion</h1>
      <div class="topbar-right">
        <app-accessibility-toolbar></app-accessibility-toolbar>
        <app-user-session-summary></app-user-session-summary>
      </div>
    </header>

    <div class="content-breadcrumbs">
      <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
    </div>

    <main class="content">
      <section class="card" *ngIf="postulacion as item; else sinDetalleTpl">
        <div class="card-head">
          <div>
            <h2>{{ item.nombreProyecto }}</h2>
            <p class="subtitle">{{ mensaje }}</p>
          </div>

          <div class="head-actions">
            <button *ngIf="origen === 'patrocinio'" type="button" class="btn-top btn-back" (click)="volverAPatrocinio()">
              Volver a patrocinio
            </button>
            <button *ngIf="puedeFirmarPatrocinio" type="button" class="btn-top btn-sign" (click)="abrirModalFirma()">
              Firmar patrocinio
            </button>
            <span class="tag-readonly" *ngIf="!puedeFirmarPatrocinio">Solo lectura</span>
          </div>
        </div>

        <div class="detail-grid">
          <div><strong>ID Postulacion:</strong> {{ item.idPostulacion }}</div>
          <div><strong>Concurso:</strong> {{ item.concurso }}</div>
          <div><strong>Subdireccion:</strong> {{ item.subdireccion }}</div>
          <div><strong>Departamento / Facultad:</strong> {{ item.departamentoFacultad }}</div>
          <div><strong>Folio:</strong> {{ item.folio }}</div>
          <div><strong>Estado:</strong> {{ etiquetaEstadoPostulacionActual }}</div>
          <div><strong>Avance:</strong> {{ item.avancePorcentaje ?? 0 }}%</div>
          <div><strong>Anio:</strong> {{ item.anio }}</div>
          <div><strong>Fecha inicio:</strong> {{ item.fechaInicio }}</div>
          <div><strong>Fecha termino:</strong> {{ item.fechaTermino }}</div>
        </div>

        <section class="section-card" *ngIf="mostrarSeccionPatrocinio">
          <div class="section-head">
            <h3>Formalizacion de patrocinio</h3>
            <span class="status-pill">{{ etiquetaEstadoPatrocinio }}</span>
          </div>
          <p>
            Esta postulacion requiere dejar constancia oficial del respaldo institucional. Revisa el detalle del concurso y
            formaliza la firma cuando la solicitud este disponible para respuesta institucional.
          </p>
          <ul class="detail-list">
            <li>Solicitud de patrocinio: <strong>{{ item.solicitudPatrocinio ? 'Activa' : 'No aplica' }}</strong>.</li>
            <li>Estado actual del patrocinio: <strong>{{ etiquetaEstadoPatrocinio }}</strong>.</li>
            <li *ngIf="firmaPatrocinioRegistrada">La firma institucional ya fue registrada en el historial del proceso.</li>
            <li *ngIf="puedeFirmarPatrocinio">La solicitud esta pendiente de firma y puede ser formalizada desde esta vista.</li>
          </ul>
          <p class="mensaje" *ngIf="mensajeFirma">{{ mensajeFirma }}</p>
        </section>

        <section class="section-card">
          <h3>Resumen del proyecto</h3>
          <p>
            Esta vista deja disponible la informacion principal de la postulacion para revision de analista, URC o
            representante institucional segun corresponda.
          </p>
        </section>

        <section class="section-card">
          <h3>Seguimiento</h3>
          <ul class="detail-list">
            <li>El concurso asociado corresponde a <strong>{{ item.concurso }}</strong>.</li>
            <li>La subdireccion responsable es <strong>{{ item.subdireccion }}</strong>.</li>
            <li>El folio de referencia es <strong>{{ item.folio }}</strong>.</li>
            <li>El avance actual reportado es <strong>{{ item.avancePorcentaje ?? 0 }}%</strong>.</li>
          </ul>
        </section>
      </section>

      <ng-template #sinDetalleTpl>
        <section class="card empty-card">
          <h2>Detalle no disponible</h2>
          <p class="subtitle">{{ mensaje }}</p>
        </section>
      </ng-template>
    </main>
  </div>
</div>

<div class="modal-backdrop" *ngIf="modalFirmaVisible">
  <div class="modal-card" role="dialog" aria-modal="true" aria-label="Confirmar firma de patrocinio">
    <h3>Confirmar firma de patrocinio</h3>
    <p class="modal-lead">
      Al confirmar, quedara registrada la firma institucional y el proceso pasara a patrocinio formalizado.
    </p>

    <div class="decision-summary" *ngIf="postulacion as item">
      <div><strong>ID Postulacion:</strong> {{ item.idPostulacion }}</div>
      <div><strong>Concurso:</strong> {{ item.concurso }}</div>
      <div><strong>Titulo Proyecto:</strong> {{ item.nombreProyecto }}</div>
      <div><strong>Folio:</strong> {{ item.folio }}</div>
    </div>

    <p class="mensaje mensaje-warning" *ngIf="mensajeFirma">{{ mensajeFirma }}</p>

    <div class="modal-actions">
      <button type="button" class="btn-top btn-back" (click)="cerrarModalFirma()">Cancelar</button>
      <button type="button" class="btn-top btn-sign" [disabled]="firmandoPatrocinio" (click)="confirmarFirmaPatrocinio()">
        {{ firmandoPatrocinio ? 'Registrando...' : 'Confirmar firma' }}
      </button>
    </div>
  </div>
</div>
